var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCrown = function SvgIconCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 13.667H4.667a.504.504 0 0 1-.5-.5c0-.274.226-.5.5-.5h6.666c.274 0 .5.226.5.5 0 .273-.226.5-.5.5ZM13.567 2.68 10.9 4.587a.671.671 0 0 1-1.013-.307L8.627.92a.664.664 0 0 0-1.247 0L6.113 4.273a.657.657 0 0 1-1.006.307L2.44 2.673c-.533-.373-1.24.154-1.02.774l2.773 7.766c.094.267.347.44.627.44h6.353a.67.67 0 0 0 .627-.44l2.773-7.766c.227-.62-.48-1.147-1.006-.767Zm-3.9 6.153H6.333a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h3.334c.273 0 .5.227.5.5 0 .274-.227.5-.5.5Z",
    fill: "#FFD31A"
  })));
};
export default SvgIconCrown;